export default __webpack_public_path__ + "static/media/logo.d06e4bca.png";